import { render, staticRenderFns } from "./LandingLayout.vue?vue&type=template&id=24d3b46b&scoped=true"
import script from "./LandingLayout.vue?vue&type=script&lang=js"
export * from "./LandingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d3b46b",
  null
  
)

export default component.exports